import { render, staticRenderFns } from "./RespondsView.vue?vue&type=template&id=f2a49da0&"
import script from "./RespondsView.vue?vue&type=script&lang=js&"
export * from "./RespondsView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports